import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumParamType, EnumParamTypeOption } from "./EnumParamType";
import { EnumParamField, EnumParamFieldOption } from "./EnumParamField";
import UiGroup from "./UiGroup";

/**
 * HS编码（品牌类型）表单
 * @description 自动生成的代码,请勿修改
 */
export default class DtoFormBrand extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 名称
     */
    Name?: string;
    /**
     * 海关代码
     */
    Code?: string;
    /**
     * 全名
     */
    FullName?: string;
    /**
     * 
     */
    OriginalFullName?: string;
    /**
     * 
     */
    Type?: EnumParamType;
    /**
     * 
     */
    Field?: EnumParamField;
}

/**
 * HS编码（品牌类型）表单-表单校验
 */
export const DtoFormBrandRules = {
    Name: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "blur",
        },
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
    Code: [
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
    FullName: [
        {
            max: 10240,
            message: "文本长度不能超过 10240 个字符",
            trigger: "blur",
        },
    ],
}

/**
 * HS编码（品牌类型）表单-设置项
 */
export const DtoFormBrandMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "Name",
    Label: "名称",
    Customize: true,
  },
  {
    Prop: "Code",
    Label: "海关代码",
    Customize: true,
  },
  {
    Prop: "FullName",
    Label: "全名",
    Customize: true,
  },
]
